import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ClassificationMeter from '@components/charts/classificationMeter/index'

import { StatusContainer, ClassificationContainer } from './styles'

const DiabetesStatus = ({
  diabetesData, status, onChange, loading, beneficiaryWithCollectionCount
}) => {
  const {
    hasDiabetes,
    amputation,
    diabeticFoot,
    nephropathy,
    type2,
    allDiabetes,
    controlledGlycatedHemoglobin,
    diabeticFootEvaluated
  } = diabetesData || 0

  return (
    <StatusContainer>
      <ClassificationContainer>
        <ClassificationMeter
          loading={loading}
          type="diabetic"
          status={status}
          onSelect={onChange}
          value={hasDiabetes}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="amputation"
          status={status}
          onSelect={onChange}
          value={amputation}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="diabeticFoot"
          status={status}
          onSelect={onChange}
          value={diabeticFoot}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="nephropathy"
          status={status}
          onSelect={onChange}
          value={nephropathy}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="type2"
          status={status}
          onSelect={onChange}
          value={type2}
          maxValue={allDiabetes}
        />
        <ClassificationMeter
          loading={loading}
          type="controlledGlycatedHemoglobin"
          status={status}
          onSelect={onChange}
          value={controlledGlycatedHemoglobin}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="diabeticFootEvaluated"
          status={status}
          onSelect={onChange}
          value={diabeticFootEvaluated}
          maxValue={beneficiaryWithCollectionCount}
        />

      </ClassificationContainer>

    </StatusContainer>
  )
}

DiabetesStatus.propTypes = {
  loading: PropTypes.bool,
  diabetesData: PropTypes.shape({
    hasDiabetes: PropTypes.number,
    amputation: PropTypes.number,
    diabeticFoot: PropTypes.number,
    nephropathy: PropTypes.number,
    type2: PropTypes.number,
    controlledGlycatedHemoglobin: PropTypes.number,
    diabeticFootEvaluated: PropTypes.number,
  }),
  status: PropTypes.shape({
    noRisk: PropTypes.bool,
    lowRisk: PropTypes.bool,
    mediumRisk: PropTypes.bool,
    highRisk: PropTypes.bool,
    diabetic: PropTypes.bool,
    hypertensive: PropTypes.bool,
    dyslipidemic: PropTypes.bool,
    overweight: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  beneficiaryWithCollectionCount: PropTypes.number,
}

DiabetesStatus.defaultProps = {
  diabetesData: null,
  loading: false,
  beneficiaryWithCollectionCount: 0,
}

const mapStateToProps = ({ overview, beneficiary }) => ({
  diabetesData: overview.diabetesData,
  beneficiaryWithCollectionCount: beneficiary.beneficiaryWithCollectionCount,
})

export default connect(mapStateToProps, null)(DiabetesStatus)
